<template>
  <div class="stage stage-2">
    <div class="stage-header">
      <h3>02: ACTIVITY DETAILS</h3>
    </div>
    <div class="stage-body">
      <div class="details activity-details">
        <label>Name *</label>
        <input 
          type="text" 
          placeholder="Name" 
          v-model="workoutName"
          :class="{ error: errors.workoutName }" />
        <label>Description</label>
        <textarea 
          :class="{ error: errors.workoutDescription }"
          v-model="workoutDescription"
          placeholder="Description"></textarea>
        <div class="detail-row">
          <div class="detail-col">
            <label v-if="activity">Date *</label>
            <datetime
              v-if="activity"
              type="date"
              v-model="workoutDate"
              :class="{ error: errors.workoutDate }"
              @input="$emit('update-attribute', { type:'workoutDate', value: $event })"
            ></datetime>
          </div>
          <div class="detail-col">
            <label>Start time *</label>
            <select :class="{ error: errors.workoutTime }" v-model="workoutTime">
              <option value="" disabled>Start time</option>
              <option value="morning">Morning</option>
              <option value="lunchtime">Lunchtime</option>
              <option value="afternoon">Afternoon</option>
              <option value="night">Night</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

export default {
  name: "ActivityDetails",

  props: {
    errors: {
      type: Object,
      required: true,
    }
  },

  components: {
    Datetime,
  },

  mounted() {
    this.workoutDate = new Date().toISOString();
  },

  computed: {
    activity() {
      return this.$store.state.activity.activity;
    },
    
    workoutName: {
      get () {
        return this.$store.state.activity.workoutName
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutName'})
      }
    },

    workoutDescription: {
      get () {
        return this.$store.state.activity.workoutDescription
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutDescription'})
      }
    },

    workoutDate: {
      get () {
        return this.$store.state.activity.workoutDate
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutDate'})
      }
    },

    workoutTime: {
      get () {
        return this.$store.state.activity.workoutTime
      },
      set (value) {
        this.$store.commit('activity/updateAttribute', {value: value, type: 'workoutTime'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.stage {
  width: 100%;
  padding-bottom: $spacing-base;

  .stage-header {
    padding: $spacing-base;
    display: flex;
    h3 {
      font-size: 14px;
      font-weight: 700;
      padding: 0;
      margin: 0;
      color: white;
    }
  }

  .stage-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: $spacing-base;
    
    .activity-details {
      max-width: 600px;
      
      p {
        color: $sec4;
        font-weight: 500;
        font-size: 14px;
        padding: 0;
        margin: 0;
      }

      .slider {
        margin-top: $spacing-base;
      }
    }

    .details {
      padding: $spacing-base;
      padding-top: 0;
      display: flex;
      flex-direction: column;

      .detail-row {
        display: flex;
        margin-top: $spacing-base;
        flex-direction: row;
        gap: $spacing-base;

        .detail-col {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
      }

      label {
        font-weight: 500;
        font-size: 14px;
        color: $sec5;
        margin-top: $spacing-base;
      }

      label:first-of-type {
        margin-top: 0;
      }
    }

    .section-header {
      display: flex;
      flex-direction: row;
      padding: $spacing-base;
      h3 {
        margin: 0;
        padding: 0;
        font-weight: 500;
        color: $sec0;
        font-size: 1em;
      }
    }
  }
}

.error {
  border: 1px solid $red1 !important;
}

.error-text {
  color: $red1 !important;
}

a {
  color: $blue;
  font-size: 0.8em;
  cursor: pointer;
  user-select: none;
  margin-left: $spacing_base;
  margin-bottom: $spacing_base;
}

.pictures {
  p {
    font-size: 14px;
    color: $sec5;
    font-weight: 500;
    margin-left: $spacing-base;
    margin-top: 0;
  }
}
</style>
